import apiClient from "./config";

const architectService = {
  // Get all architects
  getAllArchitects: async () => {
    try {
      const response = await apiClient.get("/architects");
      return response.data.architects || [];
    } catch (error) {
      console.error(
        "Error in getAllArchitects:",
        error.response?.data || error.message
      );
      throw new Error(
        error.response?.data?.message || "Failed to fetch architects"
      );
    }
  },

  // Get architect by ID
  getArchitectById: async (architectId) => {
    try {
      const response = await apiClient.get(`/architects/${architectId}`);
      return response.data.architect;
    } catch (error) {
      console.error(
        "Error in getArchitectById:",
        error.response?.data || error.message
      );
      throw new Error(
        error.response?.data?.message || "Failed to fetch architect details"
      );
    }
  },

  // Create new architect
  createArchitect: async (architectData) => {
    try {
      const response = await apiClient.post("/architects", architectData);
      return response.data.architect;
    } catch (error) {
      console.error(
        "Error in createArchitect:",
        error.response?.data || error.message
      );
      throw new Error(
        error.response?.data?.message || "Failed to create architect"
      );
    }
  },

  // Update architect
  updateArchitect: async (architectId, architectData) => {
    try {
      const response = await apiClient.put(
        `/architects/${architectId}`,
        architectData
      );
      return response.data.architect;
    } catch (error) {
      console.error(
        "Error in updateArchitect:",
        error.response?.data || error.message
      );
      throw new Error(
        error.response?.data?.message || "Failed to update architect"
      );
    }
  },

  // Delete architect
  deleteArchitect: async (architectId) => {
    try {
      const response = await apiClient.delete(`/architects/${architectId}`);
      return response.data;
    } catch (error) {
      console.error(
        "Error in deleteArchitect:",
        error.response?.data || error.message
      );
      throw new Error(
        error.response?.data?.message || "Failed to delete architect"
      );
    }
  },
};

export default architectService;
